import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import EditIcon from '@mui/icons-material/Edit';
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useSelector } from "react-redux";
import dayjs from "dayjs";

import DataTable from "../../../../components/common/datatable/DataTable";
import ButtonComponent from "../../../../components/common/button/Button";

const DataDetails = (props) => {
  // const [headerItems, setHeaderItems] = useState(null);
  const [disableFilterBtn, setDisableFilterBtn] = useState(true);
  const [isGridReady, setIsGridReady] = useState(false);
  const procurementDivision = useSelector((state) => state?.userCardType?.procurementDivisionType);
  const [columnState, setColumnState] = useState(null);
  const [selectedColumn, setSelectedColumn] = useState('');

  const renderExpandableText = (params, maxLength = 50) => {
    const text = params.value || ""; // The error details text
    const isLongText = text.length > maxLength;

    // Initialize the showFullText property for the row if not already set
    if (!params.node.showFullText) {
      params.node.showFullText = false;
    }

    const toggleText = () => {
      params.node.showFullText = !params.node.showFullText;
      params.api.refreshCells({ rowNodes: [params.node], force: true }); // Refresh the cell to update the UI
    };

    return isLongText ? (
      <div>
        {params.node.showFullText ? (
          <>
            <span>{text}</span>{" "}
            <button
              onClick={toggleText}
              style={{
                background: "none",
                border: "none",
                color: "#181d1f",
                cursor: "pointer",
                textDecoration: "underline",
                fontWeight: "bold",
              }}
            >
              Less
            </button>
          </>
        ) : (
          <>
            <span>{text.substring(0, maxLength)}...</span>{" "}
            <button
              onClick={toggleText}
              style={{
                background: "none",
                border: "none",
                color: "#181d1f",
                cursor: "pointer",
                textDecoration: "underline",
                fontWeight: "bold",
              }}
            >
              More
            </button>
          </>
        )}
      </div>
    ) : (
      <span>{text}</span>
    );
  };

  const formatTimestamp = (timestamp) => {
      if (!timestamp) return "-";
      return dayjs(timestamp).format("DD-MMM-YYYY HH:mm:ss");
    };

  const columnData = useMemo(() => {
    if(procurementDivision === 'SIS'){
      return [
        {
          headerName: "Year",
          field: "yearSIS",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Price Tag ID",
          field: "priceTagId",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Division",
          field: "division",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Change Date",
          field: "changeDate",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Plant Id",
          field: "plantId",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Sap Plant Number",
          field: "sapPlantId",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Plant Name",
          field: "plantName",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Supplier Id",
          field: "supplierId",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Sap Vendor Number",
          field: "sapSupplierId",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          editable: props.userRole === "Viewer" ? false : true,
          cellClass: props.userRole === "Viewer" ? "" : "cpsComments-cell",
          cellEditor: "agTextCellEditor",
          // onCellValueChanged: (params) =>
          //   props.handleCellValueChange(params, "sapSupplierId"),
          // valueSetter: (params) =>
          //   props.handleCellValueChange(params, "sapSupplierId"),
          valueSetter: (params) => {
            if (params.newValue !== params.oldValue) {
              const dataCopy = { ...params.data, sapSupplierId: params.newValue };
              params.node.setData(dataCopy);
              return true;
            }
            return false;
          },
          cellRenderer: (params) => {
            return (
              <div className="cps-comments-icon">
                <span style={{ flex: 1, padding: "0px 4px" }}>
                  {params.value}{" "}
                </span>
                {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
              </div>
            );
          },
        },
        {
          headerName: "Sap Vendor Description",
          field: "sapSupplierDescription",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "paymentTerms-cell",
        },
        {
          headerName: "Supplier",
          field: "supplierName",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Location Name",
          field: "locationName",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Supplier Country",
          field: "facilitycountry",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "PIN",
          field: "pin",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Sap Material Number",
          field: "sapMaterialNumber",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          editable: props.userRole === "Viewer" ? false : true,
          cellClass: props.userRole === "Viewer" ? "" : "cpsComments-cell",
          cellEditor: "agTextCellEditor",
          // onCellValueChanged: (params) =>
          //   props.handleCellValueChange(params, "sapMaterialNumber"),
          // valueSetter: (params) =>
          //   props.handleCellValueChange(params, "sapMaterialNumber"),
          valueSetter: (params) => {
            if (params.newValue !== params.oldValue) {
              const dataCopy = { ...params.data, sapMaterialNumber: params.newValue };
              params.node.setData(dataCopy);
              return true;
            }
            return false;
          },
          cellRenderer: (params) => {
            return (
              <div className="cps-comments-icon">
                <span style={{ flex: 1, padding: "0px 4px" }}>
                  {params.value}{" "}
                </span>
                {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
              </div>
            );
          },
        },
        {
          headerName: "Sap Material Description",
          field: "sapMaterialDescription",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "paymentTerms-cell",
        },
        {
          headerName: "Material Group",
          field: "extMaterialGroup",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Ingredient",
          field: "ingredient",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Package Name",
          field: "packageName",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Package Size",
          field: "packSize",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Bulk Flag",
          field: "isbulk",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "UOM",
          field: "uom",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          // editable: true,
          // cellClass: "cpsComments-cell",
          // cellEditor: "agTextCellEditor",
          // valueSetter: (params) => {
          //   if (params.newValue !== params.oldValue) {
          //     const dataCopy = { ...params.data, uom: params.newValue };
          //     params.node.setData(dataCopy);
          //     return true;
          //   }
          //   return false;
          // },
          // cellRenderer: (params) => {
          //   return (
          //     <div className="cps-comments-icon">
          //       <span style={{ flex: 1, padding: "0px 4px" }}>
          //         {params.value}{" "}
          //       </span>
          //       <EditIcon fontSize="sm" />
          //     </div>
          //   );
          // },
        },
        {
          headerName: "Price per Kg",
          field: "pricePerKG",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Currency",
          field: "currency",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          editable: props.userRole === "Viewer" ? false : true,
          cellClass: props.userRole === "Viewer" ? "" : "cpsComments-cell",
          cellEditor: "agTextCellEditor",
          // onCellValueChanged: (params) =>
          //   props.handleCellValueChange(params, "currency"),
          // valueSetter: (params) =>
          //   props.handleCellValueChange(params, "currency"),
          valueSetter: (params) => {
            if (params.newValue !== params.oldValue) {
              const dataCopy = { ...params.data, currency: params.newValue };
              params.node.setData(dataCopy);
              return true;
            }
            return false;
          },
          cellRenderer: (params) => {
            return (
              <div className="cps-comments-icon">
                <span style={{ flex: 1, padding: "0px 4px" }}>
                  {params.value}{" "}
                </span>
                {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
              </div>
            );
          },
        },
        {
          headerName: "Effective From",
          field: "effectiveStartDate",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Effective To",
          field: "effectiveEndDate",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Allocation Quantity",
          field: "allocationQty",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Allocation Notes",
          field: "allocationNotes",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "paymentTerms-cell",
        },
        {
          headerName: "From (Qty)",
          field: "fromQty",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "To (Qty)",
          field: "toQty",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "MOQ Comments",
          field: "moqComments",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "paymentTerms-cell status-cell",
          cellRenderer: (params) => renderExpandableText(params, 50),
        },
        {
          headerName: "Payment Term",
          field: "paymentTerms",
          sortable: true,
          resizable: true,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          editable: props.userRole === "Viewer" ? false : true,
          cellClass: props.userRole === "Viewer" ? "" : "paymentTerms-cell cpsComments-cell",
          cellEditor: "agTextCellEditor",
          // onCellValueChanged: (params) =>
          //   props.handleCellValueChange(params, "paymentTerms"),
          // valueSetter: (params) =>
          //   props.handleCellValueChange(params, "paymentTerms"),
          valueSetter: (params) => {
            if (params.newValue !== params.oldValue) {
              const dataCopy = { ...params.data, paymentTerms: params.newValue };
              params.node.setData(dataCopy);
              return true;
            }
            return false;
          },
          cellRenderer: (params) => {
            return (
              <div className="cps-comments-icon">
                <span style={{ flex: 1, padding: "0px 4px" }}>
                  {params.value}{" "}
                </span>
                {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
              </div>
            );
          },
        },
        {
          headerName: "Manufacturing Lead Time",
          field: "manufacturingLeadTime",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          editable: props.userRole === "Viewer" ? false : true,
          cellClass: props.userRole === "Viewer" ? "" : "cpsComments-cell",
          cellEditor: "agTextCellEditor",
          // onCellValueChanged: (params) =>
          //   props.handleCellValueChange(params, "manufacturingLeadTime"),
          // valueSetter: (params) =>
          //   props.handleCellValueChange(params, "manufacturingLeadTime"),
          valueSetter: (params) => {
            if (params.newValue !== params.oldValue) {
              const dataCopy = { ...params.data, manufacturingLeadTime: params.newValue };
              params.node.setData(dataCopy);
              return true;
            }
            return false;
          },
          cellRenderer: (params) => {
            return (
              <div className="cps-comments-icon">
                <span style={{ flex: 1, padding: "0px 4px" }}>
                  {params.value}{" "}
                </span>
                {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
              </div>
            );
          },
        },
        {
          headerName: "Auto Co Ship",
          field: "autoCoship",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Inco Terms",
          field: "incoterms",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Named Place",
          field: "namedPlace",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "paymentTerms-cell",
        },
        {
          headerName: "Supply Point Number",
          field: "supplypointid",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Supply Point Description",
          field: "supplypointname",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "paymentTerms-cell",
        },
        {
          headerName: "Manager Initials",
          field: "managerInitials",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Manager",
          field: "managerName",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "PC Initial",
          field: "pcInitial",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "SCA",
          field: "sca",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "PMU Date",
          field: "pmUdate",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          valueFormatter: (params) => formatTimestamp(params.value),
        },
        {
          headerName: "Price Per Lb",
          field: "pricePerLb",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Manufacturing Facility Number",
          field: "facilitynum",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Manufacturing Facility Description",
          field: "facilityname",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "paymentTerms-cell",
        },
        {
          headerName: "S-Code",
          field: "specequivalentcode",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        // {
        //   headerName: 'X',
        //   field: "x",
        //   sortable: true,
        //   resizable: false,
        //   filterParams: commonFilterParams,
        //   filter: commonFilter,
        //   suppressMovable: true,
        //   unSortIcon: true,
        //   cellClassRules: {
        //     'bold-cell': (params) => params.data.changedFieldNames?.includes('x')
        //   }
        // },
        {
          headerName: "Religious Attributes",
          headerClass: "center-header",
          children: [
            {
              headerName: "Halal",
              field: "halalstatus",
              sortable: true,
              resizable: false,
              unSortIcon: true,
            },
            {
              headerName: "Kosher PO",
              field: "kosherPO",
              sortable: true,
              resizable: false,
              unSortIcon: true,
            },
            {
              headerName: "Kosher Yr",
              field: "kosherYr",
              sortable: true,
              resizable: false,
              unSortIcon: true,
            },
            {
              headerName: "Kosher",
              field: "kosherstatus",
              sortable: true,
              resizable: false,
              unSortIcon: true,
            },
            {
              headerName: "Kosher Passover",
              field: "kosherkfpner",
              sortable: true,
              resizable: false,
              unSortIcon: true,
            },
            {
              headerName: "Kosher Passover (OU)",
              field: "kosherkfpou",
              sortable: true,
              resizable: false,
              unSortIcon: true,
            },
            {
              headerName: "Kosher Year (NER)",
              field: "kosherkyrner",
              sortable: true,
              resizable: false,
              unSortIcon: true,
            },
            {
              headerName: "Kosher Year (OU)",
              field: "kosherkyrou",
              sortable: true,
              resizable: false,
              unSortIcon: true,
            },
            {
              headerName: "Allergen",
              field: "allergenstatus",
              sortable: true,
              resizable: false,
              unSortIcon: true,
            },
            {
              headerName: "Allergen Description",
              field: "allergenknown",
              sortable: true,
              resizable: false,
              unSortIcon: true,
            },
            {
              headerName: "Fairtrade",
              field: "fairtradecertified",
              sortable: true,
              resizable: false,
              unSortIcon: true,
            },
          ],
        },
        {
          headerName: "Forecast",
          field: "foreCastFile",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Remarks",
          field: "mappingRemarks",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "status-cell",
          cellRenderer: (params) => renderExpandableText(params, 50),
          cellClassRules: {
            "bold-cell": (params) =>
              params.data.changedFieldNames?.includes("mappingRemarks"),
          },
        },
        {
          headerName: "Status",
          field: "status",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "status-cell",
          // valueGetter: (params) => {
          //   const userDefinedError = params.data.userDefinedError ? "User" : "System";
          //   const status = params.data.status || "N/A";
          //   return `${userDefinedError} - ${status}`;
          // },
          // cellRenderer: (params) => {
          //   const userDefinedError = params.data.userDefinedError ? "User" : "System";
          //   const status = params.data.status || "N/A";
          //   return `${userDefinedError} - ${status}`;
          // },
        },
        {
          headerName: "Error Details",
          field: "errorDetails",
          sortable: true,
          resizable: true,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "status-cell",
          cellRenderer: (params) => renderExpandableText(params, 50),
        },
        {
          headerName: "Email Recipients",
          field: "mailList",
          sortable: true,
          resizable: true,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "status-cell",
          cellRenderer: (params) => renderExpandableText(params, 50),
        },
        {
          headerName: "CPS Comments",
          field: "cpsComments",
          sortable: false,
          resizable: false,
          unSortIcon: true,
          editable: props.userRole === "Viewer" ? false : true,
          singleClickEdit: true,
          cellClass: props.userRole === "Viewer" ? "" : "cpsComments-cell",
          cellEditor: "agTextCellEditor",
          // onCellValueChanged: (params) =>
          //   props.handleCellValueChange(params, "cpsComments"),
          // valueSetter: (params) =>
          //   props.handleCellValueChange(params, "cpsComments"),
          valueSetter: (params) => {
            if (params.newValue !== params.oldValue) {
              const dataCopy = { ...params.data, cpsComments: params.newValue };
              params.node.setData(dataCopy);
              return true;
            }
            return false;
          },
          cellRenderer: (params) => {
            return (
              <div className="cps-comments-icon">
                <span style={{ flex: 1, padding: "0px 4px" }}>
                  {params.value}{" "}
                </span>
                {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
              </div>
            );
          },
        },
      ];
    } else if(procurementDivision === 'Agri'){
      return [
        {
          headerName: "S No.",
          field: "snumber",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Plant Name",
          field: "plantName",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Forecast File",
          field: "foreCastFile",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Currency",
          field: "currency",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          editable: props.userRole === "Viewer" ? false : true,
          cellClass: props.userRole === "Viewer" ? "" : "cpsComments-cell",
          cellEditor: "agTextCellEditor",
          // onCellValueChanged: (params) =>
          //   props.handleCellValueChange(params, "currency"),
          // valueSetter: (params) =>
          //   props.handleCellValueChange(params, "currency"),
          valueSetter: (params) => {
            if (params.newValue !== params.oldValue) {
              const dataCopy = { ...params.data, currency: params.newValue };
              params.node.setData(dataCopy);
              return true;
            }
            return false;
          },
          cellRenderer: (params) => {
            return (
              <div className="cps-comments-icon">
                <span style={{ flex: 1, padding: "0px 4px" }}>
                  {params.value}{" "}
                </span>
                {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
              </div>
            );
          },
        },
        {
          headerName: "Group",
          field: "groupAgri",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Supplier",
          field: "supplierName",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Plant Id",
          field: "plantId",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Vendor Number",
          field: "vendorNumber",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          editable: props.userRole === "Viewer" ? false : true,
          cellClass: props.userRole === "Viewer" ? "" : "cpsComments-cell",
          cellEditor: "agTextCellEditor",
          // onCellValueChanged: (params) =>
          //   props.handleCellValueChange(params, "vendorNumber"),
          // valueSetter: (params) =>
          //   props.handleCellValueChange(params, "vendorNumber"),
          valueSetter: (params) => {
            if (params.newValue !== params.oldValue) {
              const dataCopy = { ...params.data, vendorNumber: params.newValue };
              params.node.setData(dataCopy);
              return true;
            }
            return false;
          },
          cellRenderer: (params) => {
            return (
              <div className="cps-comments-icon">
                <span style={{ flex: 1, padding: "0px 4px" }}>
                  {params.value}{" "}
                </span>
                {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
              </div>
            );
          },
        },
        {
          headerName: "Sub Category",
          field: "subCategory",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Brand",
          field: "brand",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Prorement Manager",
          field: "prorementManager",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Material Number",
          field: "materialNumber",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          editable: props.userRole === "Viewer" ? false : true,
          cellClass: props.userRole === "Viewer" ? "" : "cpsComments-cell",
          cellEditor: "agTextCellEditor",
          // onCellValueChanged: (params) =>
          //   props.handleCellValueChange(params, "materialNumber"),
          // valueSetter: (params) =>
          //   props.handleCellValueChange(params, "materialNumber"),
          valueSetter: (params) => {
            if (params.newValue !== params.oldValue) {
              const dataCopy = { ...params.data, materialNumber: params.newValue };
              params.node.setData(dataCopy);
              return true;
            }
            return false;
          },
          cellRenderer: (params) => {
            return (
              <div className="cps-comments-icon">
                <span style={{ flex: 1, padding: "0px 4px" }}>
                  {params.value}{" "}
                </span>
                {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
              </div>
            );
          },
        },
        {
          headerName: "Material Description",
          field: "materialDescription",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "UOM",
          field: "uom",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          // editable: true,
          // cellClass: "cpsComments-cell",
          // cellEditor: "agTextCellEditor",
          // valueSetter: (params) => {
          //   if (params.newValue !== params.oldValue) {
          //     const dataCopy = { ...params.data, uom: params.newValue };
          //     params.node.setData(dataCopy);
          //     return true;
          //   }
          //   return false;
          // },
          // cellRenderer: (params) => {
          //   return (
          //     <div className="cps-comments-icon">
          //       <span style={{ flex: 1, padding: "0px 4px" }}>
          //         {params.value}{" "}
          //       </span>
          //       <EditIcon fontSize="sm" />
          //     </div>
          //   );
          // },
        },
        {
          headerName: "Geography",
          field: "geography",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Picasso Approval",
          field: "picassoApproval",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Material Origin",
          field: "materialOrigin",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Manufacturing Lead Time",
          field: "leadTime",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          editable: props.userRole === "Viewer" ? false : true,
          cellClass: props.userRole === "Viewer" ? "" : "cpsComments-cell",
          cellEditor: "agTextCellEditor",
          // onCellValueChanged: (params) =>
          //   props.handleCellValueChange(params, "leadTime"),
          // valueSetter: (params) =>
          //   props.handleCellValueChange(params, "leadTime"),
          valueSetter: (params) => {
            if (params.newValue !== params.oldValue) {
              const dataCopy = { ...params.data, leadTime: params.newValue };
              params.node.setData(dataCopy);
              return true;
            }
            return false;
          },
          cellRenderer: (params) => {
            return (
              <div className="cps-comments-icon">
                <span style={{ flex: 1, padding: "0px 4px" }}>
                  {params.value}{" "}
                </span>
                {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
              </div>
            );
          },
        },
        {
          headerName: "Ship From Country",
          field: "shipFromCountry",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Ship From City",
          field: "shipFromCity",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Payment Term",
          field: "paymentTerm",
          sortable: true,
          resizable: true,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          editable: props.userRole === "Viewer" ? false : true,
          cellClass: props.userRole === "Viewer" ? "" : "paymentTerms-cell cpsComments-cell",
          cellEditor: "agTextCellEditor",
          // onCellValueChanged: (params) =>
          //   props.handleCellValueChange(params, "paymentTerm"),
          // valueSetter: (params) =>
          //   props.handleCellValueChange(params, "paymentTerm"),
          valueSetter: (params) => {
            if (params.newValue !== params.oldValue) {
              const dataCopy = { ...params.data, paymentTerm: params.newValue };
              params.node.setData(dataCopy);
              return true;
            }
            return false;
          },
          cellRenderer: (params) => {
            return (
              <div className="cps-comments-icon">
                <span style={{ flex: 1, padding: "0px 4px" }}>
                  {params.value}{" "}
                </span>
                {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
              </div>
            );
          },
        },
        {
          headerName: "Material Cost Per UOM",
          field: "materialCostPerUOM",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Total Cost Per UOM",
          field: "totalCostPerUOM",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "MOQ Comments",
          field: "moqComments",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "paymentTerms-cell status-cell",
          cellRenderer: (params) => renderExpandableText(params, 50)
        },
        {
          headerName: "RFA Ft Per UOM",
          field: "rfaFtPerUOM",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Bid Incoterm",
          field: "bidIncoterm",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Bid Incoterm Location",
          field: "bidIncotermLocation",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Price Effective Date",
          field: "priceEffectiveDate",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Price EndDate",
          field: "priceEndDate",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Packaging Size",
          field: "packagingSize",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Status",
          field: "status",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "status-cell",
          // valueGetter: (params) => {
          //   const userDefinedError = params.data.userDefinedError ? "User" : "System";
          //   const status = params.data.status || "N/A";
          //   return `${userDefinedError} - ${status}`;
          // },
          // cellRenderer: (params) => {
          //   const userDefinedError = params.data.userDefinedError ? "User" : "System";
          //   const status = params.data.status || "N/A";
          //   return `${userDefinedError} - ${status}`;
          // },
        },
        {
          headerName: "Error Details",
          field: "errorDetails",
          sortable: true,
          resizable: true,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "status-cell",
          cellRenderer: (params) => renderExpandableText(params, 50)
        },
        {
          headerName: "Email Recipients",
          field: "mailList",
          sortable: true,
          resizable: true,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "status-cell",
          cellRenderer: (params) => renderExpandableText(params, 50)
        },
        {
          headerName: "CPS Comments",
          field: "cpsComments",
          sortable: false,
          resizable: false,
          unSortIcon: true,
          editable: props.userRole === "Viewer" ? false : true,
          singleClickEdit: true,
          cellClass: props.userRole === "Viewer" ? "" : "cpsComments-cell",
          cellEditor: "agTextCellEditor",
          // onCellValueChanged: (params) =>
          //   props.handleCellValueChange(params, "cpsComments"),
          // valueSetter: (params) =>
          //   props.handleCellValueChange(params, "cpsComments"),
          valueSetter: (params) => {
            if (params.newValue !== params.oldValue) {
              const dataCopy = { ...params.data, cpsComments: params.newValue };
              params.node.setData(dataCopy);
              return true;
            }
            return false;
          },
          cellRenderer: (params) => {
            return (
              <div className="cps-comments-icon">
                <span style={{ flex: 1, padding: "0px 4px" }}>
                  {params.value}{" "}
                </span>
                {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
              </div>
            );
          },
        },
      ];
    } else if(procurementDivision === 'Packaging'){
      return[
        {
          headerName: "Year",
          field: "yearPckg",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Plant Id",
          field: "plantId",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Plant Name",
          field: "plantName",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Division",
          field: "division",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Forecast File",
          field: "foreCastFile",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Supplier",
          field: "supplierName",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Location Name",
          field: "locationName",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Manager",
          field: "managerName",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Material Description",
          field: "materialDescription",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "status-cell",
        },
        {
          headerName: "Last Change",
          field: "lastChange",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Named Place",
          field: "namedPlace",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Payment Description",
          field: "paymentDescription",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "status-cell",
        },
        {
          headerName: "Price",
          field: "price",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Supplier Description",
          field: "supplierDescription",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "status-cell",
        },
        {
          headerName: "Vendor Number",
          field: "vendorNumber",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          editable: props.userRole === "Viewer" ? false : true,
          cellClass: props.userRole === "Viewer" ? "" : "cpsComments-cell",
          cellEditor: "agTextCellEditor",
          // onCellValueChanged: (params) =>
          //   props.handleCellValueChange(params, "vendorNumber"),
          // valueSetter: (params) =>
          //   props.handleCellValueChange(params, "vendorNumber"),
          valueSetter: (params) => {
            if (params.newValue !== params.oldValue) {
              const dataCopy = { ...params.data, vendorNumber: params.newValue };
              params.node.setData(dataCopy);
              return true;
            }
            return false;
          },
          cellRenderer: (params) => {
            return (
              <div className="cps-comments-icon">
                <span style={{ flex: 1, padding: "0px 4px" }}>
                  {params.value}{" "}
                </span>
                {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
              </div>
            );
          },
        },
        {
          headerName: "Supplier Item No",
          field: "supplierItemNo",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Material Type",
          field: "materialType",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Currency",
          field: "currency",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          editable: props.userRole === "Viewer" ? false : true,
          cellClass: props.userRole === "Viewer" ? "" : "cpsComments-cell",
          cellEditor: "agTextCellEditor",
          // onCellValueChanged: (params) =>
          //   props.handleCellValueChange(params, "currency"),
          // valueSetter: (params) =>
          //   props.handleCellValueChange(params, "currency"),
          valueSetter: (params) => {
            if (params.newValue !== params.oldValue) {
              const dataCopy = { ...params.data, currency: params.newValue };
              params.node.setData(dataCopy);
              return true;
            }
            return false;
          },
          cellRenderer: (params) => {
            return (
              <div className="cps-comments-icon">
                <span style={{ flex: 1, padding: "0px 4px" }}>
                  {params.value}{" "}
                </span>
                {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
              </div>
            );
          },
        },
        {
          headerName: "UOM",
          field: "uom",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          // editable: true,
          // cellClass: "cpsComments-cell",
          // cellEditor: "agTextCellEditor",
          // valueSetter: (params) => {
          //   if (params.newValue !== params.oldValue) {
          //     const dataCopy = { ...params.data, uom: params.newValue };
          //     params.node.setData(dataCopy);
          //     return true;
          //   }
          //   return false;
          // },
          // cellRenderer: (params) => {
          //   return (
          //     <div className="cps-comments-icon">
          //       <span style={{ flex: 1, padding: "0px 4px" }}>
          //         {params.value}{" "}
          //       </span>
          //       <EditIcon fontSize="sm" />
          //     </div>
          //   );
          // },
        },
        {
          headerName: "Inco Terms",
          field: "incoterms",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Per Qty",
          field: "perQty",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Material Number",
          field: "ccMaterialNo",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          editable: props.userRole === "Viewer" ? false : true,
          cellClass: props.userRole === "Viewer" ? "" : "cpsComments-cell",
          cellEditor: "agTextCellEditor",
          // onCellValueChanged: (params) =>
          //   props.handleCellValueChange(params, "ccMaterialNo"),
          // valueSetter: (params) =>
          //   props.handleCellValueChange(params, "ccMaterialNo"),
          valueSetter: (params) => {
            if (params.newValue !== params.oldValue) {
              const dataCopy = { ...params.data, ccMaterialNo: params.newValue };
              params.node.setData(dataCopy);
              return true;
            }
            return false;
          },
          cellRenderer: (params) => {
            return (
              <div className="cps-comments-icon">
                <span style={{ flex: 1, padding: "0px 4px" }}>
                  {params.value}{" "}
                </span>
                {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
              </div>
            );
          },
        },
        {
          headerName: "From (Qty)",
          field: "fromQty",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "To (Qty)",
          field: "toQty",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Effective From",
          field: "effectiveStartDate",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          // provide a JS Date for AG Grid sorting/filtering
          valueGetter: (params) => {
            const v = params.data?.effectiveStartDate;
            if (!v || typeof v !== 'string') return null;
            const parts = v.split('-'); // expecting "DD-MM-YYYY"
            if (parts.length !== 3) return null;
            const day = parseInt(parts[0], 10);
            const month = parseInt(parts[1], 10) - 1;
            const year = parseInt(parts[2], 10);
            const d = new Date(year, month, day);
            return isNaN(d.getTime()) ? null : d;
          },

          // display the original "DD-MM-YYYY" string if available (keeps editor/text display unchanged)
          valueFormatter: (params) => {
            const src = params.data?.effectiveStartDate;
            if (src && typeof src === 'string') return src;
            if (params.value instanceof Date && !isNaN(params.value.getTime())) {
              const d = params.value;
              const dd = String(d.getDate()).padStart(2, '0');
              const mm = String(d.getMonth() + 1).padStart(2, '0');
              const yyyy = d.getFullYear();
              return `${dd}-${mm}-${yyyy}`;
            }
            return "-";
          },

          filter: "agDateColumnFilter",
          filterParams: {
            comparator: (filterLocalDateAtMidnight, cellValue, node) => {
              const src = node?.data?.effectiveStartDate ?? cellValue;
              if (!src) return -1;
              // parse "DD-MM-YYYY"
              const parts = typeof src === 'string' ? src.split('-') : null;
              if (!parts || parts.length !== 3) return -1;
              const d = new Date(parseInt(parts[2], 10), parseInt(parts[1], 10) - 1, parseInt(parts[0], 10));
              if (isNaN(d.getTime())) return -1;
              const cellYMD = new Date(d.getFullYear(), d.getMonth(), d.getDate());
              const filterYMD = new Date(
                filterLocalDateAtMidnight.getFullYear(),
                filterLocalDateAtMidnight.getMonth(),
                filterLocalDateAtMidnight.getDate()
              );
              if (cellYMD.getTime() === filterYMD.getTime()) return 0;
              return cellYMD.getTime() < filterYMD.getTime() ? -1 : 1;
            },
            browserDatePicker: true,
          },

          // sort by parsing the source string from the row data (robust even if other getters exist)
          sortComparator: (valueA, valueB, nodeA, nodeB) => {
            const aStr = nodeA?.data?.effectiveStartDate ?? valueA;
            const bStr = nodeB?.data?.effectiveStartDate ?? valueB;
            const parse = (s) => {
              if (!s || typeof s !== 'string') return null;
              const p = s.split('-');
              if (p.length !== 3) return null;
              const d = new Date(parseInt(p[2],10), parseInt(p[1],10)-1, parseInt(p[0],10));
              return isNaN(d.getTime()) ? null : d.getTime();
            };
            const ta = parse(aStr);
            const tb = parse(bStr);
            if (ta === null && tb === null) return 0;
            if (ta === null) return -1;
            if (tb === null) return 1;
            return ta - tb;
          },
        },
        {
          headerName: "Effective To",
          field: "effectiveEndDate",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          // provide a JS Date for AG Grid sorting/filtering
          valueGetter: (params) => {
            const v = params.data?.effectiveEndDate;
            if (!v || typeof v !== 'string') return null;
            const parts = v.split('-'); // expecting "DD-MM-YYYY"
            if (parts.length !== 3) return null;
            const day = parseInt(parts[0], 10);
            const month = parseInt(parts[1], 10) - 1;
            const year = parseInt(parts[2], 10);
            const d = new Date(year, month, day);
            return isNaN(d.getTime()) ? null : d;
          },

          // display the original "DD-MM-YYYY" string if available (keeps editor/text display unchanged)
          valueFormatter: (params) => {
            const src = params.data?.effectiveEndDate;
            if (src && typeof src === 'string') return src;
            if (params.value instanceof Date && !isNaN(params.value.getTime())) {
              const d = params.value;
              const dd = String(d.getDate()).padStart(2, '0');
              const mm = String(d.getMonth() + 1).padStart(2, '0');
              const yyyy = d.getFullYear();
              return `${dd}-${mm}-${yyyy}`;
            }
            return "-";
          },

          filter: "agDateColumnFilter",
          filterParams: {
            comparator: (filterLocalDateAtMidnight, cellValue, node) => {
              const src = node?.data?.effectiveEndDate ?? cellValue;
              if (!src) return -1;
              // parse "DD-MM-YYYY"
              const parts = typeof src === 'string' ? src.split('-') : null;
              if (!parts || parts.length !== 3) return -1;
              const d = new Date(parseInt(parts[2], 10), parseInt(parts[1], 10) - 1, parseInt(parts[0], 10));
              if (isNaN(d.getTime())) return -1;
              const cellYMD = new Date(d.getFullYear(), d.getMonth(), d.getDate());
              const filterYMD = new Date(
                filterLocalDateAtMidnight.getFullYear(),
                filterLocalDateAtMidnight.getMonth(),
                filterLocalDateAtMidnight.getDate()
              );
              if (cellYMD.getTime() === filterYMD.getTime()) return 0;
              return cellYMD.getTime() < filterYMD.getTime() ? -1 : 1;
            },
            browserDatePicker: true,
          },

          // sort by parsing the source string from the row data (robust even if other getters exist)
          sortComparator: (valueA, valueB, nodeA, nodeB) => {
            const aStr = nodeA?.data?.effectiveEndDate ?? valueA;
            const bStr = nodeB?.data?.effectiveEndDate ?? valueB;
            const parse = (s) => {
              if (!s || typeof s !== 'string') return null;
              const p = s.split('-');
              if (p.length !== 3) return null;
              const d = new Date(parseInt(p[2],10), parseInt(p[1],10)-1, parseInt(p[0],10));
              return isNaN(d.getTime()) ? null : d.getTime();
            };
            const ta = parse(aStr);
            const tb = parse(bStr);
            if (ta === null && tb === null) return 0;
            if (ta === null) return -1;
            if (tb === null) return 1;
            return ta - tb;
          },
        },
        {
          headerName: "Sap Payment Term",
          field: "sapPaymentTerm",
          sortable: true,
          resizable: true,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          editable: props.userRole === "Viewer" ? false : true,
          cellClass: props.userRole === "Viewer" ? "" : "paymentTerms-cell cpsComments-cell",
          cellEditor: "agTextCellEditor",
          // onCellValueChanged: (params) =>
          //   props.handleCellValueChange(params, "sapPaymentTerm"),
          // valueSetter: (params) =>
          //   props.handleCellValueChange(params, "sapPaymentTerm"),
          valueSetter: (params) => {
            if (params.newValue !== params.oldValue) {
              const dataCopy = { ...params.data, sapPaymentTerm: params.newValue };
              params.node.setData(dataCopy);
              return true;
            }
            return false;
          },
          cellRenderer: (params) => {
            return (
              <div className="cps-comments-icon">
                <span style={{ flex: 1, padding: "0px 4px" }}>
                  {params.value}{" "}
                </span>
                {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
              </div>
            );
          },
        },
        {
          headerName: "Manufacturing Lead Time",
          field: "manufacturingLeadTime",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          editable: props.userRole === "Viewer" ? false : true,
          cellClass: props.userRole === "Viewer" ? "" : "cpsComments-cell",
          cellEditor: "agTextCellEditor",
          // onCellValueChanged: (params) =>
          //   props.handleCellValueChange(params, "manufacturingLeadTime"),
          // valueSetter: (params) =>
          //   props.handleCellValueChange(params, "manufacturingLeadTime"),
          valueSetter: (params) => {
            if (params.newValue !== params.oldValue) {
              const dataCopy = { ...params.data, manufacturingLeadTime: params.newValue };
              params.node.setData(dataCopy);
              return true;
            }
            return false;
          },
          cellRenderer: (params) => {
            return (
              <div className="cps-comments-icon">
                <span style={{ flex: 1, padding: "0px 4px" }}>
                  {params.value}{" "}
                </span>
                {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
              </div>
            );
          },
        },
        {
          headerName: "MOQ Comments",
          field: "moqComments",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "paymentTerms-cell status-cell",
          cellRenderer: (params) => renderExpandableText(params, 50)
        },
        {
          headerName: "Status",
          field: "status",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "status-cell",
          // valueGetter: (params) => {
          //   const userDefinedError = params.data.userDefinedError ? "User" : "System";
          //   const status = params.data.status || "N/A";
          //   return `${userDefinedError} - ${status}`;
          // },
          // cellRenderer: (params) => {
          //   const userDefinedError = params.data.userDefinedError ? "User" : "System";
          //   const status = params.data.status || "N/A";
          //   return `${userDefinedError} - ${status}`;
          // },
        },
        {
          headerName: "Error Details",
          field: "errorDetails",
          sortable: true,
          resizable: true,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "status-cell",
          cellRenderer: (params) => renderExpandableText(params, 50)
        },
        {
          headerName: "Email Recipients",
          field: "mailList",
          sortable: true,
          resizable: true,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "status-cell",
          cellRenderer: (params) => renderExpandableText(params, 50)
        },
        {
          headerName: "CPS Comments",
          field: "cpsComments",
          sortable: false,
          resizable: false,
          unSortIcon: true,
          editable: props.userRole === "Viewer" ? false : true,
          singleClickEdit: true,
          cellClass: props.userRole === "Viewer" ? "" : "cpsComments-cell",
          cellEditor: "agTextCellEditor",
          // onCellValueChanged: (params) =>
          //   props.handleCellValueChange(params, "cpsComments"),
          // valueSetter: (params) =>
          //   props.handleCellValueChange(params, "cpsComments"),
          valueSetter: (params) => {
            if (params.newValue !== params.oldValue) {
              const dataCopy = { ...params.data, cpsComments: params.newValue };
              params.node.setData(dataCopy);
              return true;
            }
            return false;
          },
          cellRenderer: (params) => {
            return (
              <div className="cps-comments-icon">
                <span style={{ flex: 1, padding: "0px 4px" }}>
                  {params.value}{" "}
                </span>
                {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
              </div>
            );
          },
        },
      ];
    } else if (procurementDivision === 'CEPG') {
      return [
        {
          headerName: 'Plant Id',
          field: "plant",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Plant Name',
          field: "plantName",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Material Number',
          field: "material",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          editable: props.userRole === "Viewer" ? false : true,
          cellClass: props.userRole === "Viewer" ? "" : "cpsComments-cell",
          cellEditor: "agTextCellEditor",
          // onCellValueChanged: (params) =>
          //   props.handleCellValueChange(params, "material"),
          // valueSetter: (params) =>
          //   props.handleCellValueChange(params, "material"),
          valueSetter: (params) => {
            if (params.newValue !== params.oldValue) {
              const dataCopy = { ...params.data, material: params.newValue };
              params.node.setData(dataCopy);
              return true;
            }
            return false;
          },
          cellRenderer: (params) => {
            return (
              <div className="cps-comments-icon">
                <span style={{ flex: 1, padding: "0px 4px" }}>
                  {params.value}{" "}
                </span>
                {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
              </div>
            );
          },
        },
        {
          headerName: 'Material Description',
          field: "description",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "status-cell",
          cellRenderer: (params) => renderExpandableText(params, 50)
        },
        {
          headerName: 'Package Size',
          field: "packSize",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'S-Code',
          field: "scode",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Year',
          field: "year",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Division',
          field: "division",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Forecast File',
          field: "foreCastFile",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Manager',
          field: "manager",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Gmp Lead',
          field: "gmpLead",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Change Date',
          field: "changeDate",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Named Place',
          field: "namedPlace",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Price',
          field: "price",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Supplier Description',
          field: "supplierName",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "status-cell",
          cellRenderer: (params) => renderExpandableText(params, 50)
        },
        {
          headerName: 'Vendor Number',
          field: "supplierNumber",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          editable: props.userRole === "Viewer" ? false : true,
          cellClass: props.userRole === "Viewer" ? "" : "cpsComments-cell",
          cellEditor: "agTextCellEditor",
          // onCellValueChanged: (params) =>
          //   props.handleCellValueChange(params, "supplierNumber"),
          // valueSetter: (params) =>
          //   props.handleCellValueChange(params, "supplierNumber"),
          valueSetter: (params) => {
            if (params.newValue !== params.oldValue) {
              const dataCopy = { ...params.data, supplierNumber: params.newValue };
              params.node.setData(dataCopy);
              return true;
            }
            return false;
          },
          cellRenderer: (params) => {
            return (
              <div className="cps-comments-icon">
                <span style={{ flex: 1, padding: "0px 4px" }}>
                  {params.value}{" "}
                </span>
                {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
              </div>
            );
          },
        },
        {
          headerName: 'Material Type',
          field: "material",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Currency',
          field: "currency",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          editable: props.userRole === "Viewer" ? false : true,
          cellClass: props.userRole === "Viewer" ? "" : "cpsComments-cell",
          cellEditor: "agTextCellEditor",
          // onCellValueChanged: (params) =>
          //   props.handleCellValueChange(params, "currency"),
          // valueSetter: (params) =>
          //   props.handleCellValueChange(params, "currency"),
          valueSetter: (params) => {
            if (params.newValue !== params.oldValue) {
              const dataCopy = { ...params.data, currency: params.newValue };
              params.node.setData(dataCopy);
              return true;
            }
            return false;
          },
          cellRenderer: (params) => {
            return (
              <div className="cps-comments-icon">
                <span style={{ flex: 1, padding: "0px 4px" }}>
                  {params.value}{" "}
                </span>
                {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
              </div>
            );
          },
        },
        {
          headerName: 'UOM',
          field: "uom",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          editable: props.userRole === "Viewer" ? false : true,
          cellClass: props.userRole === "Viewer" ? "" : "cpsComments-cell",
          cellEditor: "agTextCellEditor",
          valueSetter: (params) => {
            if (params.newValue !== params.oldValue) {
              const dataCopy = { ...params.data, uom: params.newValue };
              params.node.setData(dataCopy);
              return true;
            }
            return false;
          },
          cellRenderer: (params) => {
            return (
              <div className="cps-comments-icon">
                <span style={{ flex: 1, padding: "0px 4px" }}>
                  {params.value}{" "}
                </span>
                {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
              </div>
            );
          },
        },
        {
          headerName: 'Inco Terms',
          field: "incoterms",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'From (Qty)',
          field: "fromQty",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'To (Qty)',
          field: "toQty",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Effective From',
          field: "effectiveFrom",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Effective To',
          field: "effectiveTo",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'PIN',
          field: "pin",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Alocation Quantity',
          field: "allocationQtyKg",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Allocation Notes',
          field: "allocationNotes",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Sap Payment Term',
          field: "paymentTerm",
          sortable: true,
          resizable: true,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          editable: props.userRole === "Viewer" ? false : true,
          cellClass: props.userRole === "Viewer" ? "" : "paymentTerms-cell cpsComments-cell",
          cellEditor: "agTextCellEditor",
          // onCellValueChanged: (params) =>
          //   props.handleCellValueChange(params, "paymentTerm"),
          // valueSetter: (params) =>
          //   props.handleCellValueChange(params, "paymentTerm"),
          valueSetter: (params) => {
            if (params.newValue !== params.oldValue) {
              const dataCopy = { ...params.data, paymentTerm: params.newValue };
              params.node.setData(dataCopy);
              return true;
            }
            return false;
          },
          cellRenderer: (params) => {
            return (
              <div className="cps-comments-icon">
                <span style={{ flex: 1, padding: "0px 4px" }}>
                  {params.value}{" "}
                </span>
                {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
              </div>
            );
          },
        },
        {
          headerName: 'Picasso Facility',
          field: "picassoFacility",
          sortable: true,
          resizable: true,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "paymentTerms-cell",
        },
        {
          headerName: 'Manufacturing Lead Time',
          field: "manufacturingLeadTime",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          editable: props.userRole === "Viewer" ? false : true,
          cellClass: props.userRole === "Viewer" ? "" : "cpsComments-cell",
          cellEditor: "agTextCellEditor",
          // onCellValueChanged: (params) =>
          //   props.handleCellValueChange(params, "manufacturingLeadTime"),
          // valueSetter: (params) =>
          //   props.handleCellValueChange(params, "manufacturingLeadTime"),
          valueSetter: (params) => {
            if (params.newValue !== params.oldValue) {
              const dataCopy = { ...params.data, manufacturingLeadTime: params.newValue };
              params.node.setData(dataCopy);
              return true;
            }
            return false;
          },
          cellRenderer: (params) => {
            return (
              <div className="cps-comments-icon">
                <span style={{ flex: 1, padding: "0px 4px" }}>
                  {params.value}{" "}
                </span>
                {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
              </div>
            );
          },
        },
        {
          headerName: 'MOQ Comments',
          field: "moqComments",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "status-cell",
          cellRenderer: (params) => renderExpandableText(params, 50)
        },
        {
          headerName: 'Open PO',
          field: "openPO",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'CPS Comments',
          field: "cpsComments",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Status',
          field: "status",
          sortable: true,
          resizable: true,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "status-cell",
        },
         {
          headerName: 'Error Details',
          field: "errorDetails",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "status-cell",
          cellRenderer: (params) => renderExpandableText(params, 50)
        },
        {
          headerName: "Email Recipients",
          field: "mailList",
          sortable: true,
          resizable: true,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "status-cell",
          cellRenderer: (params) => renderExpandableText(params, 50)
        },
        {
          headerName: "CPS Comments",
          field: "cpsComments",
          sortable: false,
          resizable: false,
          unSortIcon: true,
          editable: props.userRole === "Viewer" ? false : true,
          singleClickEdit: true,
          cellClass: props.userRole === "Viewer" ? "" : "cpsComments-cell",
          cellEditor: "agTextCellEditor",
          // onCellValueChanged: (params) =>
          //   props.handleCellValueChange(params, "cpsComments"),
          // valueSetter: (params) =>
          //   props.handleCellValueChange(params, "cpsComments"),
          valueSetter: (params) => {
            if (params.newValue !== params.oldValue) {
              const dataCopy = { ...params.data, cpsComments: params.newValue };
              params.node.setData(dataCopy);
              return true;
            }
            return false;
          },
          cellRenderer: (params) => {
            return (
              <div className="cps-comments-icon">
                <span style={{ flex: 1, padding: "0px 4px" }}>
                  {params.value}{" "}
                </span>
                {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
              </div>
            );
          },
        },
      ];
    }
  }, [procurementDivision, props.data])

  const selectionColumnDef = useMemo(() => ({
    pinned: "left",
  }), []);

  const gridApiRef = useRef(null); // Reference to the grid API

  const onColumnChange = e => {
    const col = e.target.value;
    setSelectedColumn(col);
    if (col && gridApiRef.current) {
      gridApiRef.current.ensureColumnVisible(col);
    }
  };

  const onGridReady = (params) => {
    gridApiRef.current = params.api; // Store the grid API instance
    setIsGridReady(true);
    if (columnState) {
      params.columnApi.applyColumnState({ state: columnState, applyOrder: true });
    }
  };

  useEffect(() => {
    if (isGridReady && gridApiRef?.current) {
      const savedFilterModel = localStorage.getItem("dataErrorsFilterModel");
      if (savedFilterModel) {
        gridApiRef.current.setFilterModel(JSON.parse(savedFilterModel));
        setDisableFilterBtn(true);
      }
    }
  }, [isGridReady]);

  const clearAllFilters = () => {
    if (gridApiRef.current) {
      gridApiRef.current.setFilterModel(null); // Clear all filters
      localStorage.removeItem("dataErrorsFilterModel");
      setDisableFilterBtn(true);
    }
  };

  const onFilterChanged = () => {
    if (gridApiRef.current) {
      const filterModel = gridApiRef.current.getFilterModel();
      setDisableFilterBtn(Object.keys(filterModel).length === 0); // Enable button if filters exist
      localStorage.setItem("dataErrorsFilterModel", JSON.stringify(filterModel));
    }
  };

  const onColumnMoved = useCallback((params) => {
    if (params && params.columnApi && typeof params.columnApi.getColumnState === "function") {
      setColumnState(params.columnApi.getColumnState());
    }
  }, []);

  const gridOptions = {
    getRowId: (params) => {
      return `${params?.data?.runOutputSeqId}`
    },
    overlayLoadingTemplate: `<span class="ag--overlay-loading-center" >Please wait while data is loading</span>`,
    overlayNoRowsTemplate: `<span class="ag--overlay-no-rows-center" >No Data Available</span>`,
    defaultColDef: {
      sortable: true,
      filter: 'agMultiColumnFilter',
      autoHeight: true,
      cellStyle: {
        whiteSpace: "normal",
        wordBreak: "break-word",
        lineHeight: 1.5,
        display: "flex",
        alignItems: "center",
      },
      valueGetter: (params) => {
        if (!params.data) return "-";

        const field = params.colDef.field;
        const value = params.data[field];

        return value === null || value === undefined || value === ""
          ? "-"
          : value;
      },
    },
    onColumnMoved,
    onFilterChanged,
  }

  const getContextMenuItems = (params) => {
    const defaultItems = params.defaultItems || [];

    // Remove the 'export' option
    return defaultItems.filter(item => item !== 'export');
  };

  return (
    <>
      <div style={{display: 'flex', marginBottom: '20px', justifyContent: 'space-between', alignItems: 'center'}}>
        <FormControl sx={{ m: 1, minWidth: 200 }} size="small">
          <InputLabel>Jump to Column</InputLabel>
          <Select
            id="col-select"
            value={selectedColumn}
            label="Jump to Column"
            onChange={onColumnChange}
          >
            <MenuItem value="">Select Column</MenuItem>
            {columnData?.map(col => (
              <MenuItem key={col?.field} value={col?.field}>
                {col?.headerName || col?.field}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <ButtonComponent
          maxWidth="150px"
          label="Clear All Filters"
          bgColor="black"
          color="white"
          disabled={disableFilterBtn}
          onClick={clearAllFilters}
        />
      </div>
      { props?.data &&
      <DataTable
        columns={columnData}
        rows={props?.data || []}
        paginationProp={props?.pagination}
        paginationPageSize={props?.paginationPageSize}
        paginationPageSizeSelector={props?.paginationPageSizeSelector}
        // enableCheckbox={false}
        onRowSelected={props?.onRowSelected}
        selectionColumnDef={selectionColumnDef}
        rowSelection={props.rowSelection}
        onSelectionChanged={props.onSelectionChanged}
        onGridReady={onGridReady}
        gridOptions={gridOptions}
        getRowStyle={props.getRowStyle}
        onCellValueChanged={props.handleCellValueChange}
        getContextMenuItems={getContextMenuItems}
      />
      }
    </>
  );
};

export default DataDetails;
